
    <div class="vouchers-list fade-in-animation">
      <div *ngIf="!vouchers.length && !vouchersToGenerate.length" class="no-vouchers">
        <img src="assets/shared/img/svg/sad_face.svg" alt="Sem vouchers">
        <p>{{noVouchersMessage}}</p>
      </div>

      <vouchers-card
        *ngFor="let voucher of vouchersToGenerate"
        [voucher]="voucher"
        [toGenerate]="true">
      </vouchers-card>

      <vouchers-card
        *ngFor="let voucher of vouchers"
        [voucher]="voucher"
      >
      </vouchers-card>

    </div>
  